import { Injectable } from '@angular/core';

import { ReportTableColumn } from '../models/report-table';

import { ReportType } from '../models/report-types';
import { ReportFilters, ReportPayload } from '../models/report-payload';

import { Columns } from '../configs/report-columns.config';

@Injectable({
  providedIn: 'root'
})
export class ReportTableService {

  constructor() { }

  getColumns(reportType: ReportType, payload: ReportPayload): ReportTableColumn[] {
    const columns: Record<ReportType | string, (payload: ReportPayload) => ReportTableColumn[]> = {
      [ReportType.REPORTE_PARADAS_MOVIMIENTOS]: this.getColumnReportStopsAndMoves,
      [ReportType.REPORTE_EXCESOS_VELOCIDAD_LIMITE_PERSONALIZADO]: this.getColumnReportSpeedingLimitCustomized,
      [ReportType.REPORTE_ENTRADA_SALIDA_GEOCERCAS]: this.getColumnReportGeofenceEntryExit,
      [ReportType.REPORTE_COMBUSTIBLE_GENERAL]: this.getColumnReportGeneralFuel,
      [ReportType.REPORTE_COMBUSTIBLE_RESUMEN]: this.getColumnReportSummaryFuel,
      [ReportType.REPORTE_GENERAL]: this.getColumnReportGeneral,
      [ReportType.REPORTE_ATENCION_EVENTOS]: this.getColumnReportEventAttention,
      [ReportType.REPORTE_COORDENADAS_GEOCERCAS]: this.getcolumnReportGeofenceCoordinates,
      [ReportType.REPORTE_COORDENADAS_GEOPUNTOS]: this.getcolumnReportGeopointCoordinates,
      [ReportType.REPORTE_COORDENADAS_GEOCERCAS_CIRCULARES]: this.getcolumnReportCircularGeofenceCoordinates,
      [ReportType.REPORTE_EVENTOS_INTERNO]: this.getColumnReportInternalEvents.bind(this),
      [ReportType.REPORTE_EXCESOS_VELOCIDAD_DURACION_TOLERANCIA_NIVEL_RIESGO]: this.getColumnReportSpeedingDurationToleranceRiskLevel,
      [ReportType.REPORTE_EXCESOS_VELOCIDAD_DIRECCION_DURACION_TOLERANCIA_NIVEL_RIESGO]: this.getColumnReportSpeedingDurationToleranceRiskLevel,
      [ReportType.REPORTE_ESTADO_TRANSMISION]: this.getColumnReportTransmissionStatus,
      [ReportType.REPORTE_ESTADO_TRANSMISION_EVENTOS]: this.getColumnReportEstadoTransmissionEvents,
      [ReportType.REPORTE_EXCESOS_VELOCIDAD_POR_NIVEL]: this.getColumnReportSpeedingDurationToleranceRiskLevel,
      [ReportType.REPORTE_RESUMEN_POR_DIA_NUEVO]: this.getColumnReportSummaryByNewDay,
      [ReportType.REPORTE_RELENTI]: this.getColumnReportRelenti,
      // [ReportType.REPORTE_MONITOREO_CANTIDAD_EVENTOS
      [ReportType.REPORTE_POSICION]: this.getColumnReportPosition,
      [ReportType.REPORTE_EVENTOS]: this.getColumnReportEvent,
      [ReportType.REPORTE_RECORRIDO]: this.getColumnReportRecorrido,
      [ReportType.REPORTE_CHECKLIST]: this.getColumnReportChecklist,
      [ReportType.REPORTE_OPERATIVIDAD_EQUIPO]: this.getColumnReportOperatividadEquipos,
      [ReportType.REPORTE_BOLIVIA]: this.getColumnReportOperatividadEquipos,
      [ReportType.REPORTE_MONITOREO_CANTIDAD_EVENTOS_POR_UNIDAD]: this.getColumnReportMonitoreoCantidadEventsByUnits,
      [ReportType.REPORTE_CONDUCTORES_ENROLADOS]: this.getColumnsReportDriversEnrollments,
      [ReportType.REPORTE_EXCESOS_VELOCIDAD_DIRECCION_NIVEL]: this.getColumnsReportExcesoVelocidadDireccionNivel,
      [ReportType.REPORTE_EVENTOS_FORMATO_PAXI]: this.getColumnsReportEventosFormatoPaxi,
      [ReportType.REPORTE_PARADAS_MOVIMIENTOS_NUEVO]: this.getColumnReportStopsAndMoves2,
      [ReportType.REPORTE_PRIMER_MOVIMIENTO]: this.getColumnReportFirstMovement,
      [ReportType.REPORTE_PARADAS_MOVIMIENTOS_ENHANCED]: this.getColumnReportStopsAndMoves2,
      // [ReportType.REPORTE_ALERTAS]: this.getColumnReportAlert, ...
    };
    const fn = columns[reportType];
    const result = fn?.(payload) ?? [];

    return result.filter((col): col is ReportTableColumn => col !== undefined);
  }

  private getColumnsReportEventosFormatoPaxi(reportPayload: ReportPayload): ReportTableColumn[] {
    console.log("get column report event", reportPayload)
    const filters: ReportFilters = reportPayload.filters;
    const eventColumns = reportPayload.eventConfig.eventColumns;
    let columns: ReportTableColumn[] = [
      Columns.item,
    ];

    columns.push(Columns.fecha);

    if (eventColumns.Codigo) columns.push(Columns.codigo);
    if (eventColumns.Placa) columns.push(Columns.unidad);

    if (eventColumns.campoGerencia) columns.push(Columns.gerencia);
    if (eventColumns.campoRuta) columns.push(Columns.ruta);
    if (eventColumns.Conductor) columns.push(Columns.conductor);
    if (eventColumns.Zona) columns.push(Columns.nombreGeocerca);

    columns.push(Columns.horaInicio);
    columns.push(Columns.horaFin);
    if (eventColumns.campoDuracion) columns.push(Columns.duracion);
    if (eventColumns.VelMaxima) columns.push(Columns.velocidadMax);
    if (eventColumns.Niveles) {
      columns.push(Columns.nivel1);
      columns.push(Columns.nivel2);
      columns.push(Columns.nivel3);
    }
    if (eventColumns.campoFalta) columns.push(Columns.falta);
    if (eventColumns.EnlaceArchivo) columns.push(Columns.enlaceArchivo);
    if (eventColumns.Ubicacion) {
      //columns.push(Columns.ubicacion);
      columns.push(Columns.latitud);
      columns.push(Columns.longitud);
    }

    return columns;
  }

  // REPORTE DE EXCESO DE VELOCIDAD DIRECCION NIVEL
  private getColumnsReportExcesoVelocidadDireccionNivel(reportPayload: ReportPayload): ReportTableColumn[] {
    // // FORMATO EXCESO DE VELICIDAD PERSONALIZADA
    // const filters: ReportFilters = reportPayload.filters;
    // let columns: ReportTableColumn[] = [
    //   Columns.item,
    // ];
    // columns.push(Columns.nombre);

    // if (!filters.includeDateHour) {
    //   columns.push(Columns.fechaYHora);
    // } else {
    //   columns.push(Columns.fecha, Columns.hora);
    // }
    // columns.push(Columns.zonaGeocerca);
    // columns.push(Columns.direccionGeocerca);
    // columns.push(Columns.limiteVelocidadZona);

    // //===============================
    // let excesoVelocidad = Columns.excesoVelocidad
    // excesoVelocidad.subColumns = [];

    // if(filters.includeRiesgo){
    //   excesoVelocidad.width = "450px"
    //   const subCols = [Columns.nivel1, Columns.nivel2, Columns.nivel3];
    //   excesoVelocidad.subColumns.push(...subCols);
    // }else{
    //   excesoVelocidad.width = "100px"
    // }
    // columns.push(excesoVelocidad); // añadir subcolumnas

    // columns.push(Columns.ubicacion);
    // columns.push(Columns.puntoCercano);
    // columns.push(Columns.referencia);

    // return columns;
    // ======================================================
    // FORMATO EXCESO DE DE VELOCIDAD CON DURACION Y RESUMEN
    const filters: ReportFilters = reportPayload.filters;
    const eventColumns = reportPayload.eventConfig.eventColumns;
    let columns: ReportTableColumn[] = [
      Columns.itemResumen,
    ];

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHora);
    }
    if (filters.includeDateHour) {
      if (eventColumns.Fecha) {
        columns.push(Columns.fecha);
      }
      if (eventColumns.hora) {
        columns.push(Columns.hora);
      }
    }

    if (eventColumns.Codigo) columns.push(Columns.unidad);
    if (eventColumns.Placa) columns.push(Columns.placa);
    if (eventColumns.Zona) columns.push(Columns.zonaGeocerca);
    columns.push(Columns.limiteVelocidadZona);

    columns.push(Columns.direccionGeocerca);

    let excesoVelocidad = Columns.excesoVelocidad
    // Asegurarse de que subColumns exista
    excesoVelocidad.subColumns = [];

    if (filters.includeRiesgo) {
      excesoVelocidad.width = "450px"
      const subCols = [Columns.nivel1, Columns.nivel2, Columns.nivel3];
      excesoVelocidad.subColumns.push(...subCols);
    } else {
      excesoVelocidad.width = "100px"
    }
    columns.push(excesoVelocidad); // añadir subcolumnas

    columns.push(Columns.inicioExceso);
    columns.push(Columns.horaExceso);
    columns.push(Columns.finExceso);
    columns.push(Columns.duracion);



    if (eventColumns.IdConductor) columns.push(Columns.idConductor);
    if (eventColumns.Conductor) columns.push(Columns.conductor);
    if (eventColumns.VelMobileye) columns.push(Columns.velocidadADAS);
    if (eventColumns.VelGPSspeed) columns.push(Columns.velocidadGPSSpeed);
    if (eventColumns.VelCAN) columns.push(Columns.velocidadCan);
    if (eventColumns.Satelite) columns.push(Columns.satelite);
    if (eventColumns.Ubicacion) columns.push(Columns.ubicacion);


    return columns;
  }

  // REPORTE DE CONDUCTORES ENROLADOS
  private getColumnsReportDriversEnrollments(reportPayload: ReportPayload): ReportTableColumn[] {
    let columns: ReportTableColumn[] = [
      Columns.item,
      Columns.vehiculo,
      Columns.conductor,
      Columns.dni,
      Columns.codigoCipia,
      Columns.fechaEnrolado,
      Columns.horaEnrolado,
    ];
    return columns;
  }

  // REPORTE MONITOREO CANTIDAD DE EVENTOS POR UNIDAD
  private getColumnReportMonitoreoCantidadEventsByUnits(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;
    const eventColumns = reportPayload.eventConfig.eventColumns;

    let columns: ReportTableColumn[] = [
      Columns.item,
      Columns.estado
    ];

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraInicio);
    } else {
      columns.push(Columns.fechaInicio, Columns.horaInicio);
    }

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraFin);
    } else {
      columns.push(Columns.fechaFin, Columns.horaFin);
    }

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraServidorInicio);
    } else {
      columns.push(Columns.fechaServidorInicio, Columns.horaServidorInicio);
    }

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraServidorFin);
    } else {
      columns.push(Columns.fechaServidorFin, Columns.horaServidorFin);
    }



    columns.push(Columns.duracion);
    columns.push(Columns.velocidad);
    columns.push(Columns.ignicion);
    columns.push(Columns.puntoCercano);
    columns.push(Columns.nombreGeocerca);
    columns.push(Columns.referencia);
    columns.push(Columns.ubicacion);

    return columns;
  }

  // REPORTE DE ESTADO DE TRANSMISSION EVENTOS
  private getColumnReportEstadoTransmissionEvents(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;
    const eventColumns = reportPayload.eventConfig.eventColumns;

    let columns: ReportTableColumn[] = [
      Columns.item,
      Columns.estado
    ];

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraInicio);
    } else {
      columns.push(Columns.fechaInicio, Columns.horaInicio);
    }

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraFin);
    } else {
      columns.push(Columns.fechaFin, Columns.horaFin);
    }

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraServidorInicio);
    } else {
      columns.push(Columns.fechaServidorInicio, Columns.horaServidorInicio);
    }

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraServidorFin);
    } else {
      columns.push(Columns.fechaServidorFin, Columns.horaServidorFin);
    }



    columns.push(Columns.duracion);
    columns.push(Columns.velocidad);
    columns.push(Columns.ignicion);
    columns.push(Columns.puntoCercano);
    columns.push(Columns.nombreGeocerca);
    columns.push(Columns.referencia);
    columns.push(Columns.ubicacion);

    return columns;
  }


  // REPORTE DE OPERATIVIDAD DE EQUIPOS
  private getColumnReportOperatividadEquipos(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;
    const eventColumns = reportPayload.eventConfig.eventColumns;

    let columns: ReportTableColumn[] = [
      Columns.item,
    ];
    if (eventColumns.Codigo) columns.push(Columns.codigo);
    if (eventColumns.Placa) columns.push(Columns.placa);

    if (eventColumns.Fecha) {
      if (!filters.includeDateHour) {
        columns.push(Columns.fechaTracker);
      } else {
        columns.push(Columns.fecha, Columns.hora);
      }
    }

    if (eventColumns.estadoGPS) columns.push(Columns.estadoGps);
    if (eventColumns.estadoCipia) columns.push(Columns.estadoCipia);
    if (eventColumns.campoFatiga) columns.push(Columns.estado360);
    if (eventColumns.campoCaredrive) columns.push(Columns.caredrive);
    if (eventColumns.campoCAN) columns.push(Columns.can);
    if (eventColumns.campoADAS) columns.push(Columns.adas);
    if (eventColumns.campoAlcotester) columns.push(Columns.alcotester);



    // estadoGPS: false,
    // estadoCipia: false,
    // campoFatiga: false,
    // campoCaredrive: false,
    // campoCAN: false,
    // campoADAS: false,
    // campoAlcotester: false,



    // let columns: ReportTableColumn[] = [
    //   Columns.item,
    //   Columns.codigo,
    //   Columns.placa,
    //   Columns.estadoGps,
    //   Columns.fechaTracker,
    //   Columns.estadoCipia,
    //   Columns.estado360,
    //   Columns.caredrive,
    //   Columns.can,
    //   Columns.adas,
    //   Columns.alcotester
    // ];

    //     if (eventColumns.VelGPSspeed) columns.push(Columns.velocidadGPSSpeed);


    return columns;
  }

  // REPORTE DE RELENTI
  private getColumnReportRelenti(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;

    let columns: ReportTableColumn[] = [
      Columns.item,
    ];

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraInicio);
    } else {
      columns.push(Columns.fechaInicio, Columns.horaInicio);
    }

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraFin);
    } else {
      columns.push(Columns.fechaFin, Columns.horaFin);
    }

    columns.push(Columns.duracion);
    columns.push(Columns.referencia);

    return columns;
  }


  // REPORTE DE RECORRIDO
  private getColumnReportRecorrido(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;
    const eventColumns = reportPayload.eventConfig.eventColumns;

    let columns: ReportTableColumn[] = [
      Columns.item,
      Columns.codigo,
      Columns.placa,
      Columns.fechaInicio,
      Columns.horaInicio,
      Columns.fechaFin,
      Columns.horaFin,
      Columns.recorrido,
      Columns.tiempoMovimiento,
      Columns.tiempoRelenti,
      Columns.tiempoApagado,
      Columns.duracionParadas,
      Columns.contadorParadas,
      Columns.velocidadMax,
      Columns.velocidadPromedio,
    ];

    return columns;
  }


  // REPORTE DE CHECKLIST
  private getColumnReportChecklist(reportPayload: ReportPayload): ReportTableColumn[] {

    let datosEventos: ReportTableColumn = {
      field: 'datosEvento',
      header: 'Datos del Evento',
      type: 'text',
      width: '670px',
      subColumns: [
        Columns.nombreEvento,
        Columns.fecha,
        Columns.conductor,
      ]
    };

    let fechaChecklist: ReportTableColumn = { field: 'fechaChecklist', header: 'Fecha Checklist', type: 'text', width: '170px' };
    let conductorChecklist: ReportTableColumn = { field: 'conductorChecklist', header: 'Conductor', type: 'text', width: '170px' };

    let datosChecklist: ReportTableColumn = {
      field: 'datosChecklist',
      header: 'Datos del Checklist',
      type: 'text',
      width: '670px',
      subColumns: [
        fechaChecklist,
        conductorChecklist,
        Columns.tiempoDiferencia,
        Columns.codigoConductor,
      ]
    };

    let columns: ReportTableColumn[] = [
      Columns.item,
      Columns.codigo,
      Columns.placa,
      datosEventos,
      datosChecklist,
      Columns.previsualizacion,
      Columns.enlaceImagen,
      Columns.enlaceVideo,
    ];

    return columns;
  }


  // REPORTE DE EVENTOS
  private getColumnReportEvent(reportPayload: ReportPayload): ReportTableColumn[] {
    console.log("get column report event", reportPayload)
    const filters: ReportFilters = reportPayload.filters;
    const eventColumns = reportPayload.eventConfig.eventColumns;
    let columns: ReportTableColumn[] = [
      Columns.item,
    ];


    // Fecha y Hora (Evento)
    if (!filters.includeDateHour && eventColumns.Fecha) {
      columns.push(Columns.fechaYHoraEvento);
    }
    if (filters.includeDateHour && eventColumns.Fecha) {
      columns.push(Columns.fechaEvento, Columns.horaEvento);
    }

    // Fecha y Hora (Servidor)
    if (!filters.includeDateHour && eventColumns.FechaServidor) {
      columns.push(Columns.fechaYHoraServidor);
    }
    if (filters.includeDateHour && eventColumns.FechaServidor) {
      columns.push(Columns.fechaServidor, Columns.horaServidor);
    }

    // Evento
    if (eventColumns.NombreEvento) columns.push(Columns.nombreEvento);
    if (eventColumns.Evento) columns.push(Columns.descripcion);

    // Unidad
    if (eventColumns.Codigo) columns.push(Columns.codigo);
    if (eventColumns.Placa) columns.push(Columns.placa);
    if (eventColumns.TipoUnidad) columns.push(Columns.tipoUnidad);

    // Conductor
    if (eventColumns.IdConductor) columns.push(Columns.IdConductor);
    if (eventColumns.Conductor) columns.push(Columns.conductor);

    // Velocidades
    if (eventColumns.VelMobileye) columns.push(Columns.velocidadMobileye);
    if (eventColumns.VelGPS) columns.push(Columns.velocidadGps);
    if (eventColumns.VelGPSspeed) columns.push(Columns.velocidadGPSSpeed);
    if (eventColumns.VelCAN) columns.push(Columns.velocidadCan);
    if (eventColumns.VelECO) columns.push(Columns.velocidadEco);
    if (eventColumns.ConMasDetalle) columns.push(Columns.motivo);

    // Humedad y Temperatura
    if (eventColumns.temperatura) {
      columns.push(Columns.temperaturaMin)
      columns.push(Columns.temperaturaMax)
      columns.push(Columns.temperaturas)
    };
    if (eventColumns.humedad) {
      columns.push(Columns.humedadMin)
      columns.push(Columns.humedadMax)
      columns.push(Columns.humedades)
    };


    // Ubicación
    if (eventColumns.Zona) columns.push(Columns.nombreGeocerca);
    if (eventColumns.PuntoCercano) columns.push(Columns.puntoCercano);
    if (eventColumns.Ubicacion) columns.push(Columns.ubicacion);

    // Extras
    if (eventColumns.Referencia) columns.push(Columns.referencia);
    if (eventColumns.EnlaceArchivo) columns.push(Columns.enlaceArchivo);
    if (eventColumns.Parametros) columns.push(Columns.parametros);

    return columns;
  }

  // REPORTE DE POSICION
  private getColumnReportPosition(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;
    let columns: ReportTableColumn[] = [
      Columns.item,
    ];
    columns.push(Columns.codigo);
    columns.push(Columns.placa);

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHora);
    } else {
      columns.push(Columns.fecha, Columns.hora);
    }
    columns.push(Columns.estado);
    columns.push(Columns.conductor);
    columns.push(Columns.velocidadGps);
    columns.push(Columns.velocidadCan);
    columns.push(Columns.odometro);
    columns.push(Columns.ubicacion);
    columns.push(Columns.nombreGeocerca);
    columns.push(Columns.referencia);
    return columns
  }

  // REPORTE DE PARADAS Y MOVIMIENTOS
  private getColumnReportStopsAndMoves(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;
    let columns: ReportTableColumn[] = [
      Columns.item,
    ];
    columns.push(Columns.estado);

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraInicio);
    } else {
      columns.push(Columns.fechaInicio, Columns.horaInicio);
    }

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraFin);
    } else {
      columns.push(Columns.fechaFin, Columns.horaFin);
    }

    columns.push(Columns.duracion);

    if (filters.includeParadas) {
      columns.push(Columns.ubicacion);
    }
    if (filters.includeMovimientos) {
      columns.push(Columns.distanciaRecorrida);
      columns.push(Columns.velocidadMaxGps);
      columns.push(Columns.velocidadMaxCan);
    }

    if (filters.includeParadas) {
      columns.push(Columns.puntoCercano);
    }

    if (filters.includeMovimientos) {
      columns.push(Columns.velocidadPromedioGps);
      columns.push(Columns.velocidadPromedioCan);
    }


    if (filters.includeParadas) {
      columns.push(Columns.referencia);
    }
    return columns;
  }

  // REPORTE DE PARADAS Y MOVIMIENTOS 2
  private getColumnReportStopsAndMoves2(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;
    const eventColumns = reportPayload.eventConfig.eventColumns;
    let columns: ReportTableColumn[] = [
      Columns.item,
    ];
    columns.push(Columns.estado);

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraInicio);
    } else {
      columns.push(Columns.fechaInicio, Columns.horaInicio);
    }

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraFin);
    } else {
      columns.push(Columns.fechaFin, Columns.horaFin);
    }

    if (eventColumns.campoDuracion) {
      columns.push(Columns.duracion);
    }


    if (filters.includeMovimientos) {
      if (eventColumns.campoDistancia) {
          columns.push(Columns.distanciaRecorrida);
      }
      if (eventColumns.VelMaxGPS) {
          columns.push(Columns.velocidadMaxGps);
      }
      if (eventColumns.VelMaxCAN) {
          columns.push(Columns.velocidadMaxCan);
      }
    }

    if (filters.includeParadas) {
      if (eventColumns.Zona) {
        columns.push(Columns.nombreGeocerca);
      }
      if (eventColumns.PuntoCercano) {
        columns.push(Columns.puntoCercano);
      }
    }

    if (filters.includeMovimientos) {
      if (eventColumns.VelPromGPS) {
          columns.push(Columns.velocidadPromedioGps);
      }
      if (eventColumns.VelPromCAN) {
          columns.push(Columns.velocidadPromedioCan);
      }
    }

    if (filters.includeParadas && eventColumns.Ubicacion) {
      columns.push(Columns.ubicacion);
    }
    if (filters.includeParadas && eventColumns.Referencia) {
      columns.push(Columns.referencia);
    }
    return columns;
  }

  // REPORTE DE EXCESO DE VELOCIDAD LIMITE PERSONALIZADO
  private getColumnReportSpeedingLimitCustomized(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;
    let columns: ReportTableColumn[] = [
      Columns.item,
    ];
    columns.push(Columns.nombre);

    if (filters.includeDuracion) {
      if (!filters.includeDateHour) {
        columns.push(Columns.fechaYHoraInicio);
      } else {
        columns.push(Columns.fechaInicio, Columns.horaInicio);
      }
      if (!filters.includeDateHour) {
        columns.push(Columns.fechaYHoraFin);
      } else {
        columns.push(Columns.fechaFin, Columns.horaFin);
      }
      columns.push(Columns.cantidadTramas);
      columns.push(Columns.tramas);
      columns.push(Columns.velocidadMin);
      columns.push(Columns.velocidadMax);
      columns.push(Columns.puntoCercano);
      columns.push(Columns.zonaCercana);
      columns.push(Columns.ubicacion);
    } else {

      if (!filters.includeDateHour) {
        columns.push(Columns.fechaYHora);
      } else {
        columns.push(Columns.fecha, Columns.hora);
      }

      columns.push(Columns.velocidadMax);
      columns.push(Columns.ubicacion);
      columns.push(Columns.puntoCercano);
      columns.push(Columns.referencia);
    }

    return columns;
  }

  // REPORTE DE ENTRADA Y SALIDA DE GEOCERCAS
  private getColumnReportGeofenceEntryExit(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;
    let columns: ReportTableColumn[] = [
      Columns.item,
    ];

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraEntrada);
    } else {
      columns.push(Columns.fechaEntrada, Columns.horaEntrada);
    }

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraSalida);
    } else {
      columns.push(Columns.fechaSalida, Columns.horaSalida);
    }

    columns.push(Columns.duracion)
    columns.push(Columns.nombreGeocerca)
    columns.push(Columns.ubicacion)
    columns.push(Columns.puntoCercano)

    return columns;
  }

  // REPORTE DE COMBUSTIBLE GENERAL
  private getColumnReportGeneralFuel(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;
    let columns: ReportTableColumn[] = [
      Columns.item,
    ];
    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHora);
    } else {
      columns.push(Columns.fecha, Columns.hora);
    }

    columns.push(Columns.velocidadCan);
    columns.push(Columns.nivelCombustible);
    columns.push(Columns.consumoCombustible);
    columns.push(Columns.consumoHrfc);
    columns.push(Columns.combustibleRestante);
    columns.push(Columns.contactoMotor);
    columns.push(Columns.odometro);

    if (filters.includeOdomV) {
      columns.push(Columns.odometroVirtual);
    }

    columns.push(Columns.ubicacion);
    columns.push(Columns.canRpm);
    columns.push(Columns.altitud);
    return columns;
  }

  // REPORTE DE COMBUSTIBLE RESUMEN
  private getColumnReportSummaryFuel(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;
    let columns: ReportTableColumn[] = [
      Columns.item,
    ];

    columns.push(Columns.codigo);
    columns.push(Columns.placa);
    columns.push(Columns.fechaInicioGps, Columns.horaInicioGps);

    columns.push(Columns.fechaFinGps, Columns.horaFinGps);


    columns.push(Columns.distanciaRecorrida);
    columns.push(Columns.consumoCombustible);
    columns.push(Columns.rendimientoPorGalon);
    columns.push(Columns.velocidadPromedio);
    columns.push(Columns.tiempoMovimiento);
    columns.push(Columns.tiempoRelenti);
    columns.push(Columns.tiempoApagado);

    if (filters.includeOdomV) {
      columns.push(Columns.odometroVirtualInicial);
      columns.push(Columns.odometroVirtualFinal);
    } else {
      columns.push(Columns.odometroInicial);
      columns.push(Columns.odometroFinal);
    }
    return columns;
  }

  // REPORTE GENERAL
  private getColumnReportGeneral(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;
    const generalColumn = reportPayload.generalConfig.columns;
    let columns: ReportTableColumn[] = [
      Columns.item,
    ];

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHora);
    } else {
      columns.push(Columns.fecha, Columns.hora);
    }

    if (generalColumn.fServidor) {
      if (!filters.includeDateHour) {
        columns.push(Columns.fechaYHoraServidor);
      } else {
        columns.push(Columns.fechaServidor, Columns.horaServidor);
      }
    }

    if (generalColumn.pCercano) columns.push(Columns.puntoCercano);
    if (generalColumn.velCAN) columns.push(Columns.velocidadCan);
    if (generalColumn.velGPS) {
      columns.push(Columns.velocidad)
    }

    if (generalColumn.velGPS_speed) columns.push(Columns.velocidadGPSSpeed);
    if (generalColumn.velMobileye_ME460) columns.push(Columns.velocidadMobileye);
    if (generalColumn.velECO) columns.push(Columns.velocidadEco);
    if (generalColumn.DUOT2state) columns.push(Columns.estadoDuot2);
    if (generalColumn.RxM) columns.push(Columns.rpm);
    if (generalColumn.RPMAlta) columns.push(Columns.rpmECO);
    if (generalColumn.cNivel) columns.push(Columns.nivelCombustible);
    if (generalColumn.cRestante) columns.push(Columns.combustibleRestante);
    if (generalColumn.cMotor) columns.push(Columns.contactoMotor);
    if (generalColumn.odometro) columns.push(Columns.odometro);
    if (generalColumn.altitud) columns.push(Columns.altitud);
    if (generalColumn.angulo) columns.push(Columns.angulo);
    if (generalColumn.alimentGps) columns.push(Columns.alimentacionGPS);

    if (generalColumn.nivelBateria) columns.push(Columns.nivelBateria);
    if (generalColumn.nivelCobertura) columns.push(Columns.nivelCobertura);
    if (generalColumn.temperaturaGps) columns.push(Columns.temperaturaGps);
    if (generalColumn.eyeTemperature) columns.push(Columns.temperaturaEye);
    if (generalColumn.bleTemperature) columns.push(Columns.temperaturaBle);
    if (generalColumn.eyeHumedad) columns.push(Columns.humedadEye);
    if (generalColumn.bleHumedad) columns.push(Columns.humedadBle);

    if (generalColumn.satelite) columns.push(Columns.satelite);
    if (generalColumn.recFacial) columns.push(Columns.reconocimientoFacial);
    if (generalColumn.onOff) columns.push(Columns.ignicion);
    if (generalColumn.alcoholemia) columns.push(Columns.alcoholemia);
    if (generalColumn.parametros) columns.push(Columns.parametros);
    if (generalColumn.ubicacion) columns.push(Columns.ubicacion);
    if (generalColumn.referencia) columns.push(Columns.referencia);
    if (generalColumn.geocerca) columns.push(Columns.nombreGeocerca);
    if (generalColumn.direccionGeocerca) columns.push(Columns.direccionGeocerca);
    if (generalColumn.errorMobileye_ME427) columns.push(Columns.errorMobileye_ME427);
    if (generalColumn.fatiga) columns.push(Columns.fatiga);
    if (generalColumn.fBrusca) columns.push(Columns.frenadaBrusca);
    if (generalColumn.aBrusca) columns.push(Columns.aceleracionBrusca);
    if (generalColumn.voltageLevel) columns.push(Columns.voltageLevel);
    return columns
  }

  // REPORTE DE ATENCION DE EVENTOS
  private getColumnReportEventAttention(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;
    const eventColumns = reportPayload.eventConfig.eventColumns;
    let columns: ReportTableColumn[] = [
      Columns.item,
    ];

    if (!filters.includeDateHour && eventColumns.Fecha) {
      columns.push(Columns.fechaYHoraEvento);
    }
    if (filters.includeDateHour && eventColumns.Fecha) {
      columns.push(Columns.fechaEvento, Columns.horaEvento);
    }

    if (!filters.includeDateHour && eventColumns.FechaServidor) {
      columns.push(Columns.fechaYHoraServidor);
    }
    if (filters.includeDateHour && eventColumns.FechaServidor) {
      columns.push(Columns.fechaServidor, Columns.horaServidor);
    }


    // Evento
    if (eventColumns.NombreEvento) columns.push(Columns.nombreEvento);
    if (eventColumns.Evento) columns.push(Columns.descripcion);

    // Unidad
    if (eventColumns.Codigo) columns.push(Columns.codigo);
    if (eventColumns.Placa) columns.push(Columns.placa);
    if (eventColumns.TipoUnidad) columns.push(Columns.tipoUnidad);

    // Conductor
    if (eventColumns.IdConductor) columns.push(Columns.idConductor);
    if (eventColumns.Conductor) columns.push(Columns.conductor);
    if (eventColumns.newDriver) columns.push(Columns.newDriver);

    // atencion
    if (eventColumns.FechaEvaluacion) {
      columns.push(Columns.fechaEvaluacion);
      columns.push(Columns.horaEvaluacion);
    };
    if (eventColumns.CriterioEvaluacion) columns.push(Columns.criterioEvaluacion);
    if (eventColumns.Observacion) columns.push(Columns.observacion);

    // Velocidades
    if (eventColumns.ComRadial) columns.push(Columns.comunicacionRadial);
    if (eventColumns.VelMobileye) columns.push(Columns.velocidadMobileye);
    if (eventColumns.VelGPS) columns.push(Columns.velocidadGps);
    if (eventColumns.VelGPSspeed) columns.push(Columns.velocidadGPSSpeed);
    if (eventColumns.VelCAN) columns.push(Columns.velocidadCan);
    if (eventColumns.VelECO) columns.push(Columns.velocidadEco);

    // Ubicación
    if (eventColumns.Zona) columns.push(Columns.nombreGeocerca);
    if (eventColumns.PuntoCercano) columns.push(Columns.puntoCercano);
    if (eventColumns.Ubicacion) columns.push(Columns.ubicacion);
    if (eventColumns.Referencia) columns.push(Columns.referencia);

    // Extras
    if (eventColumns.EnlaceArchivo) columns.push(Columns.enlaceArchivo);
    if (eventColumns.OperadorMonitoreo) columns.push(Columns.operadorMonitoreo);

    return columns;
  }

  // REPORTE COORDENADAS DE GEOCERCAS
  private getcolumnReportGeofenceCoordinates(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;
    let columns: ReportTableColumn[] = [
      Columns.item,
    ];
    columns.push(Columns.numeroGeo);
    columns.push(Columns.nombreGeocerca);
    columns.push(Columns.latitud);
    columns.push(Columns.longitud);
    columns.push(Columns.velocidad);
    columns.push(Columns.velocidadMuyGrave);
    columns.push(Columns.velocidadGrave);
    columns.push(Columns.velocidadTolerancia);
    columns.push(Columns.zonaColor);
    return columns
  }

  // REPORTE COORDENADAS DE GEOPUNTOS
  private getcolumnReportGeopointCoordinates(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;
    let columns: ReportTableColumn[] = [
      Columns.item,
    ];
    columns.push(Columns.numeroPunto);
    columns.push(Columns.nombrePunto);
    columns.push(Columns.latitud);
    columns.push(Columns.longitud);
    columns.push(Columns.color);
    columns.push(Columns.visibilidadPunto);
    columns.push(Columns.visibilidadNombre);
    columns.push(Columns.latitud2);
    columns.push(Columns.longitud2);
    return columns
  }

  // REPORTE COORDENADAS DE GEOCERCAS CIRCULARES
  private getcolumnReportCircularGeofenceCoordinates(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;
    let columns: ReportTableColumn[] = [
      Columns.item,
    ];
    columns.push(Columns.numeroGeo);
    columns.push(Columns.nombreGeocerca);
    columns.push(Columns.latitud);
    columns.push(Columns.longitud);
    columns.push(Columns.radio);
    columns.push(Columns.diametro);
    columns.push(Columns.velocidad);
    columns.push(Columns.velocidadTolerancia);
    columns.push(Columns.velocidadGrave);
    columns.push(Columns.velocidadMuyGrave);
    columns.push(Columns.zonaColor);
    return columns
  }

  // REPORTE DE EVENTOS INTERNOS
  private getColumnReportInternalEvents(reportPayload: ReportPayload): ReportTableColumn[] {
    // tiene la misma estructura que el reporte de eventos
    console.log(reportPayload, "evento internos show columns")
    const columnas = this.getColumnReportEvent(reportPayload);
    return columnas
  }

  // REPORTE DE EXCESO DE VELOCIDAD - DURACION, TOLERANCIA, NIVEL DE RIESGO
  private getColumnReportSpeedingDurationToleranceRiskLevel(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;
    const eventColumns = reportPayload.eventConfig.eventColumns;
    let columns: ReportTableColumn[] = [
      Columns.itemResumen,
    ];

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHora);
    }
    if (filters.includeDateHour) {
      if (eventColumns.Fecha) {
        columns.push(Columns.fecha);
      }
      if (eventColumns.hora) {
        columns.push(Columns.hora);
      }
    }

    if (eventColumns.Codigo) columns.push(Columns.unidad);
    if (eventColumns.Placa) columns.push(Columns.placa);
    if (eventColumns.Zona) columns.push(Columns.zonaGeocerca);
    columns.push(Columns.limiteVelocidadZona);

    let excesoVelocidad = Columns.excesoVelocidad
    // Asegurarse de que subColumns exista
    excesoVelocidad.subColumns = [];

    if (filters.includeRiesgo) {
      excesoVelocidad.width = "450px"
      const subCols = reportPayload.reportDetails.reportType === ReportType.REPORTE_EXCESOS_VELOCIDAD_POR_NIVEL
        ? [Columns.nivel1, Columns.nivel2, Columns.nivel3]
        : [Columns.leve, Columns.grave, Columns.muyGrave];
      excesoVelocidad.subColumns.push(...subCols);
    } else {
      excesoVelocidad.width = "100px"
    }
    columns.push(excesoVelocidad); // añadir subcolumnas

    columns.push(Columns.inicioExceso);
    columns.push(Columns.horaExceso);
    columns.push(Columns.finExceso);
    columns.push(Columns.duracion);



    if (eventColumns.IdConductor) columns.push(Columns.idConductor);
    if (eventColumns.Conductor) columns.push(Columns.conductor);
    if (eventColumns.VelMobileye) columns.push(Columns.velocidadADAS);
    if (eventColumns.VelGPSspeed) columns.push(Columns.velocidadGPSSpeed);
    if (eventColumns.VelCAN) columns.push(Columns.velocidadCan);
    if (eventColumns.Satelite) columns.push(Columns.satelite);
    if (eventColumns.Ubicacion) columns.push(Columns.ubicacion);


    return columns;
  }

  // REPORTE DE ESTADO DE TRANSMISION
  private getColumnReportTransmissionStatus(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;
    let columns: ReportTableColumn[] = [
      Columns.item,
    ];
    columns.push(Columns.estado);

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraInicio);
    } else {
      columns.push(Columns.fechaInicio, Columns.horaInicio);
    }

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraFin);
    } else {
      columns.push(Columns.fechaFin, Columns.horaFin);
    }

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraServidorInicio);
    } else {
      columns.push(Columns.fechaServidorInicio, Columns.horaServidorInicio);
    }
    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraServidorFin);
    } else {
      columns.push(Columns.fechaServidorFin, Columns.horaServidorFin);
    }

    columns.push(Columns.duracion);
    columns.push(Columns.velocidad);
    columns.push(Columns.ignicion);
    columns.push(Columns.puntoCercano);
    columns.push(Columns.nombreGeocerca);
    columns.push(Columns.referencia);
    columns.push(Columns.ubicacion);
    return columns
  }

  // REPORTE DE RESUMEN POR DIA NUEVO
  private getColumnReportSummaryByNewDay(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;
    let columns: ReportTableColumn[] = [
      Columns.item,
    ];
    columns.push(Columns.codigo);
    columns.push(Columns.placa);
    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraInicio);
    } else {
      columns.push(Columns.fechaInicio, Columns.horaInicio);
    }
    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraFin);
    } else {
      columns.push(Columns.fechaFin, Columns.horaFin);
    }

    columns.push(Columns.recorrido);
    columns.push(Columns.tiempoMovimiento);
    columns.push(Columns.tiempoRelenti);
    columns.push(Columns.tiempoApagado);
    columns.push(Columns.duracionParadas);
    columns.push(Columns.contadorParadas);
    columns.push(Columns.velocidadMax);
    columns.push(Columns.velocidadPromedio);
    return columns;
  }

  // REPORTE DE PRIMER MOVIMIENTO
  private getColumnReportFirstMovement(reportPayload: ReportPayload): ReportTableColumn[] {
    const filters: ReportFilters = reportPayload.filters;
    let columns: ReportTableColumn[] = [
      Columns.item,
    ];
    columns.push(Columns.estado);
    columns.push(Columns.codigo);
    columns.push(Columns.placa);

    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraInicio);
    } else {
      columns.push(Columns.fechaInicio, Columns.horaInicio);
    }
    if (!filters.includeDateHour) {
      columns.push(Columns.fechaYHoraFin);
    } else {
      columns.push(Columns.fechaFin, Columns.horaFin);
    }

    columns.push(Columns.duracion);
    columns.push(Columns.ubicacion);
    columns.push(Columns.distanciaRecorrida);
    columns.push(Columns.velocidadMaxGps);
    columns.push(Columns.velocidadMaxCan);

    columns.push(Columns.puntoCercano);
    columns.push(Columns.velocidadPromedioGps);
    columns.push(Columns.velocidadPromedioCan);
    columns.push(Columns.referencia);

    return columns
  }


}
